import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Row, Col, Container, Button } from "react-bootstrap";
import DirectoryApi from "../../../api/directoryApi";
import ProgramApi from "../../../api/programApi";
import AuthApi from "../../../api/authApi";
import moment from "moment";
import { toast } from "react-toastify";
import ImagePlaceHolder from "../../../assets/images/image-placeholder.png";
import lovestrongLogo from "../../../assets/images/Lovestrong-logo.jpg";
import Profile from "../../../assets/images/couple-default.png";
import Loader from "../../../components/loader";
import DirectoryModel from "./DirectoryModel";
import DeleteModel from "../../../components/DeleteModel";
import RetreatApi from "../../../api/retreatApi";
import Helpers from "../../../components/Helpers";
import { Cookies } from "react-cookie";
import AdminApi from "../../../api/admin";
import SocialLinksModal from "../../../components/SocialLinksModal";
import corruptedImg from "../../../assets/images/corrupted-img.png";
import priestProfile from "../../../assets/images/priest-default.png";
import UpdateCouplePopUp from "../../common/UpdateCouplePopUp";
import UpdatePriestPopUp from "../../Priest/UpdatePriestPopUp";
import PriestApi from "../../../api/priestApi";

export const CreateDirectory = () => {
  const [directory, setDirectory] = useState([]);
  const [allRetreatRoasters, setAllRetreatRoasters] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [coupleTalkData, setCoupleTalkData] = useState([]);
  const [socialLinksModal, setSocialLinksModal] = useState(false);

  const [data, setData] = useState([]);
  const [loadFooter, setLoadFooter] = useState(false);
  const [loadMain, setLoadMain] = useState(false);
  const [couplePopUp, setCouplePopUp] = useState(false);
  const [priestPopUp, setPriestPopUp] = useState(false);
  const [selectedCouple, setSelectedCouple] = useState(null);
  const [selectedPriest, setSelectedPriest] = useState(null);
  const [parishList, setParishList] = useState([]);
  const [isTempUpload, setIsTempUpload] = useState(false);
  const [oldValues, setOldValues] = useState(null);
  const [roasterCount, setRoasterCount] = useState(0);
  const [roastersOfCoupleList, setRoastersOfCoupleList] = useState([]);
  const [roastersOfPriestList, setRoastersOfPriestList] = useState([]);
  let cookies = new Cookies();
  let userData = cookies.get("LoveStrongUser") || null;
  const { id } = useParams();
  let directoryApi = new DirectoryApi();
  let programApi = new ProgramApi();
  let retreatApi = new RetreatApi();
  let adminApi = new AdminApi();
  let authApi = new AuthApi();
  let priestApi = new PriestApi();

  useEffect(() => {
    getDirectoryDetail(id);
    getAllRoastersOfRetreat(id);
    getRetreatDetail(id);
    getParishList();
  }, [id]);

  const getParishList = async () => {
    await authApi.getPerishList().then((res) => {
      const sortedList = res.data.sort((a, b) =>
        a.parish.localeCompare(b.parish),
      );
      setParishList(sortedList);
    });
  };

  const getRetreatDetail = async (id) => {
    await retreatApi
      .getRetreatDetail({ id: id })
      .then((res) => {
        if (res.success) {
          const { schedule, ...rest } = res.data[0];
          const parsedSchedule = schedule ? JSON.parse(schedule) : [];
          const parsedData = {
            ...rest,
            schedule: parsedSchedule.map((entry) => ({
              date: new Date(entry.date),
              from: entry.from,
              to: entry.to,
            })),
            parish: res.data[0].parishId,
          };
          setData(parsedData);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const getDirectoryDetail = async (id) => {
    await directoryApi
      .getDirectoryDetail({ rereatId: id })
      .then((response) => {
        const directoryData = response.data[0];
        if (directoryData) {
          if (directoryData.footerImage) {
            try {
              const parsed = JSON.parse(directoryData.footerImage);
              if (Array.isArray(parsed)) {
                directoryData.footerImages = parsed;
              } else {
                // Old format - single image, convert to array
                directoryData.footerImages = [directoryData.footerImage];
              }
            } catch (e) {
              // If not JSON, treat as single image
              directoryData.footerImages = [directoryData.footerImage];
            }
          } else {
            directoryData.footerImages = [];
          }
          setDirectory(directoryData);
        } else {
          // No directory exists yet, set empty state
          setDirectory({ footerImages: [] });
        }
      })
      .catch((error) => {
        toast.error(error.toString());
        // Set empty state on error
        setDirectory({ footerImages: [] });
      });
  };

  const getAllRoastersOfRetreat = async (id) => {
    await directoryApi
      .getAllRoastersOfRetreat({ rereatId: id })
      .then((response) => {
        setAllRetreatRoasters(response.data);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const openCoupleUpdate = (couple) => {
    setRoasterCount(0);
    setRoastersOfCoupleList([]);
    const mappedCouple = {
      ...couple,
      id: couple.coupleId, // Map to actual couple ID
    };
    setSelectedCouple({
      ...mappedCouple,
      anniversary_date: couple.anniversary_date
        ? new Date(couple.anniversary_date)
        : "",
    });
    setOldValues(mappedCouple);
    setIsTempUpload(false);
    adminApi.participatedInRetreats({ couple_Id: mappedCouple.id }).then((res) => {
      if (res.success) {
        setRoasterCount(res.totalRecords);
        setRoastersOfCoupleList(res.data);
      }
    });
    setCouplePopUp(true);
  };

  const openPriestUpdate = (priest) => {
    setRoasterCount(0);
    setRoastersOfPriestList([]);
    const mappedPriest = {
      ...priest,
      id: priest.priestId, // Map to actual priest ID
      firstName: priest.priestFirstName,
      lastName: priest.priestLastName,
      email: priest.priestEmail,
      title: priest.priestTitle,
      primaryKey: priest.priestPrimaryKey,
      imageUrl: priest.priestImage,
      address: priest.priestAddress,
      city: priest.priestCity,
      state: priest.priestState,
      zip: priest.priestZip,
      parishId: priest.priestParishId,
    };
    setSelectedPriest(mappedPriest);
    setOldValues(mappedPriest);
    setIsTempUpload(false);
    priestApi.participatedInRetreats({ priest_Id: mappedPriest.id }).then((res) => {
      if (res.success) {
        setRoasterCount(res.totalRecords);
        setRoastersOfPriestList(res.data);
      }
    });
    setPriestPopUp(true);
  };

  const changePublishStatus = (directory, select) => {
    // Check if trying to publish directory without footer images
    if (select === "directory" && directory && directory.status !== "PUBLISH") {
      // Check if footer images exist - handle both new array format and old single image format
      let hasFooterImages = false;

      if (
        directory.footerImages &&
        Array.isArray(directory.footerImages) &&
        directory.footerImages.length > 0
      ) {
        hasFooterImages = true;
      } else if (directory.footerImage) {
        // Check old format - single image
        try {
          const parsed = JSON.parse(directory.footerImage);
          if (Array.isArray(parsed) && parsed.length > 0) {
            hasFooterImages = true;
          } else if (parsed && typeof parsed === "string") {
            hasFooterImages = true;
          }
        } catch (e) {
          // If not JSON, treat as single image string
          if (directory.footerImage && directory.footerImage.trim() !== "") {
            hasFooterImages = true;
          }
        }
      }

      if (!hasFooterImages) {
        toast.error(
          "At least one footer image is required to publish the directory.",
        );
        return;
      }
    }

    const retreatId = (directory && directory.retreatId) || id;
    programApi
      .changePublishStatus({
        retreatId,
        select: select,
        userData: JSON.stringify(userData),
      })
      .then((res) => {
        if (res.success) {
          getDirectoryDetail(retreatId);
          toast.success(res.msg);
        } else {
          getDirectoryDetail(retreatId);
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const upload = (i) => {
    document.getElementById(`${i}` + "-" + "CoupleProfileUpload").click();
  };

  const handleClose = () => {
    setShowDelete(false);
    setDeleteItem(null);
  };

  const DeleteData = () => {
    if (deleteItem) {
      // Extra validation: prevent deletion of last footer image
      if (
        deleteItem.checkImage === "footerImage" &&
        deleteItem.directory?.footerImages &&
        deleteItem.directory.footerImages.length <= 1
      ) {
        toast.error(
          "At least one footer image is required. Cannot remove the last image.",
        );
        handleClose();
        return;
      }
      remove(
        deleteItem.directory,
        deleteItem.selection,
        deleteItem.checkImage,
        deleteItem.imageIndex,
      );
      handleClose();
    }
  };

  const remove = (coupleDta, selection, checkImage, imageIndex) => {
    if (selection === "directory") {
      const requestData = {
        checkImage: checkImage,
        id: coupleDta.id,
      };
      // Add imageIndex for footer images
      if (checkImage === "footerImage" && imageIndex !== undefined) {
        requestData.imageIndex = imageIndex;
      }
      directoryApi
        .removeDirectoryImage(requestData)
        .then((res) => {
          if (res.success) {
            toast.success(res.msg);
            getDirectoryDetail(coupleDta.retreatId);
          } else {
            toast.error(
              res.msg || "An error occurred while removing the image.",
            );
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error("An error occurred while removing the image.");
        });
    } else if (selection === "priest") {
      directoryApi
        .removeImage({ priestId: coupleDta.priestId })
        .then((res) => {
          toast.success(res.msg);
          getAllRoastersOfRetreat(coupleDta.retreatId);
        })
        .catch((error) => {
          console.error(error);
          toast.error("An error occurred while uploading the image.");
        });
    } else if (selection === "") {
      directoryApi
        .removeImage({
          rosterId: coupleDta.id,
          coupleId: coupleDta.coupleId,
        })
        .then((res) => {
          toast.success(res.msg);
          getAllRoastersOfRetreat(coupleDta.retreatId);
        })
        .catch((error) => {
          console.error(error);
          toast.error("An error occurred while uploading the image.");
        });
    }
  };

  const hadleDirectoryModel = () => {
    setModalShow(true);
  };

  const handleallImagesChanges = (e, dir, imageSelection) => {
    if (imageSelection === "mainImage") {
      setLoadMain(true);
    } else if (imageSelection === "footerImage") {
      setLoadFooter(true);
    }
    let { name, value } = e.target;
    if (name === "imageUrl" && e.target.files && e.target.files.length > 0) {
      let allData = new FormData();
      allData.append("file", e.target.files[0]);
      allData.append("directoryId", dir && dir.id);
      allData.append("retreatId", id);
      allData.append("imageSelection", imageSelection);
      directoryApi
        .createDirectory(allData)
        .then(async (res) => {

          toast.success(res.msg);
          getDirectoryDetail(id);
          setLoadMain(false);
          setLoadFooter(false);
        })
        .catch((error) => {
          console.error(error);
          toast.error("An error occurred while uploading the image.");
        });
    } else {
      toast.error("Please select an image.");
    }
  };

  const handleImageChanges = (e, coupleDta, condition) => {
    let { name, value } = e.target;
    if (name === "imageUrl" && e.target.files && e.target.files.length > 0) {
      let allData = new FormData();
      allData.append("file", e.target.files[0]);
      if (condition === "sprDirector") {
        allData.append("priestId", coupleDta.priestId);
      } else {
        allData.append("coupleId", coupleDta.coupleId);
        allData.append("rosterId", coupleDta.id);
      }
      directoryApi
        .saveCoupleImage(allData)
        .then((res) => {
          if (res.success) {
            toast.success(res.msg || "Couple image uploaded successfully.");
            getAllRoastersOfRetreat(coupleDta.retreatId);
          } else {
            toast.error(
              res.msg || "An error occurred while uploading the image.",
            );
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error("An error occurred while uploading the image.");
        });
    } else {
      toast.error("Please select an image.");
    }
  };

  const closeDirectoryModel = () => {
    setModalShow(false);
    getDirectoryDetail(id);
  };

  const socialLinksOpen = () => {
    setSocialLinksModal(true);
  };

  const socialLinksClose = () => {
    setSocialLinksModal(false);
  };

  const handleShare = () => {
    const publicLink = `${window.location.origin}/directory/${id}`;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(publicLink)
        .then(() => {
          toast.success("Link copied successfully!");
        })
        .catch((err) => {
          toast.error("Failed to copy link");
        });
    } else {
      // Fallback
      const textArea = document.createElement("textarea");
      textArea.value = publicLink;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        toast.success("Link copied successfully!");
      } catch (err) {
        toast.error("Failed to copy link");
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <>
      <Link to="/manageRetreat" className="back-link">
        &lt;Back
      </Link>

      <div className="row ext-space create-program-page">
        <div className="col-lg-12 d-flex flex-column">
          <div className="row flex-grow">
            <div className="col-12 grid-margin stretch-card">
              <div className="card custom-card">
                <div className="card-body ">
                  <Container fluid className="create-retreat-header ">
                    <div className="row w-100 mx-0">
                      <div className="directory-header-bar">
                        <div className="directorydata">
                          <h1 className="addRetHeading">Directory -</h1>
                          <div className="mt-2 program-upper-title">
                            <h6>
                              {data && data.title
                                ? `${data &&
                                data.title &&
                                data.title.charAt(0).toUpperCase() +
                                data.title.slice(1)
                                }, `
                                : null}
                              {data.dateFrom && data.dateTo
                                ? moment(data.dateFrom).isSame(data.dateTo, "day")
                                  ? // Same day
                                  `${moment(data.dateFrom)
                                    .tz("America/New_York")
                                    .format("MMM D, YYYY")}`
                                  : moment(data.dateFrom).isSame(
                                    data.dateTo,
                                    "month",
                                  )
                                    ? // Same month, only show month once
                                    `${moment(data.dateFrom)
                                      .tz("America/New_York")
                                      .format("MMM D")} - ${moment(data.dateTo)
                                        .tz("America/New_York")
                                        .format("D")}, ${moment(data.dateFrom)
                                          .tz("America/New_York")
                                          .format("YYYY")}`
                                    : // Different months
                                    `${moment(data.dateFrom)
                                      .tz("America/New_York")
                                      .format("MMM D")} - ${moment(data.dateTo)
                                        .tz("America/New_York")
                                        .format("MMM D")}, ${moment(data.dateFrom)
                                          .tz("America/New_York")
                                          .format("YYYY")}`
                                : null}
                            </h6>
                          </div>
                        </div>

                        {id ? (
                          <div className="directory-actions">
                            <Button
                              onClick={() =>
                                changePublishStatus(directory, "directory")
                              }
                              className="btn-sm directory-action-btn"
                            >
                              {directory && directory.status === "PUBLISH"
                                ? "Unpublish"
                                : "Publish"}
                            </Button>
                            <Button
                              as="a"
                              href={`/directory/${id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              variant="primary"
                              className="btn-sm directory-action-btn"
                            >
                              Preview
                            </Button>
                            <Button
                              variant="primary"
                              className="btn-sm directory-action-btn"
                              onClick={handleShare}
                              title="Copy Directory Link"
                            >
                              <i className="mdi mdi-content-copy"></i>
                              Copy Directory Link
                            </Button>
                          </div>
                        ) : null}
                      </div>
                      <hr />
                    </div>
                    <Row>
                      <div className="text-center">
                        {" "}
                        <Col>
                          <img
                            style={{
                              height: "140px",
                              marginTop: "15px",
                            }}
                            src={lovestrongLogo}
                            loading="lazy"
                            alt="Logo"
                            srcSet=""
                          />
                        </Col>
                      </div>

                      <Col
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="directoryHeader footer-logo-image  howerOption"
                      >
                        <div>
                          {data && data.heading ? (
                            <h1>
                              <em>{data && data.heading}</em>
                            </h1>
                          ) : null}
                        </div>
                      </Col>

                      <Col
                        className="directoryImg howerOption mainHeaderImage p-0"
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                      >
                        {!data ||
                          data.image1 == "" ||
                          data.image1 == undefined ? (
                          <div className="text-center">
                            <img
                              src={ImagePlaceHolder}
                              alt=""
                              srcSet=""
                              className="imageHeader"
                            />
                          </div>
                        ) : (
                          <div className="text-center">
                            <img
                              src={data && data.image1}
                              className="imageHeader"
                              loading="lazy"
                            />
                          </div>
                        )}{" "}
                      </Col>

                      {/* {loadMain ? (
                          <div className="auth-form-light text-center main-register py-5 pt-0 px-4 px-sm-5">
                            <Row className="text-center">
                              <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className=" mt-3 p-5"
                              >
                                <Loader />
                              </Col>
                            </Row>
                          </div>
                        ) : (
                          <Col
                            className="directoryImg howerOption mainHeaderImage p-0"
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            {!directory ||
                            directory.headerImage == "" ||
                            directory.headerImage == undefined ? (
                              <div className="text-center">
                                <img
                                  src={ImagePlaceHolder}
                                  alt=""
                                  srcSet=""
                                  className="imageHeader"
                                />
                              </div>
                            ) : (
                              <div className="text-center">
                                <>
                                  <img
                                    src={directory && directory.headerImage}
                                    className="imageHeader"
                                  />
                                </>{" "}
                              </div>
                            )}{" "}
                            <div className="text-center setUploadField">
                              {!directory ||
                              directory.headerImage == "" ||
                              directory.headerImage == undefined ? (
                                <>
                                  <input
                                    name="imageUrl"
                                    className="pt-1"
                                    type="file"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    id={
                                      `${directory && directory.id}` +
                                      30 +
                                      "-" +
                                      "CoupleProfileUpload"
                                    }
                                    onChange={(e) =>
                                      handleallImagesChanges(
                                        e,
                                        directory,
                                        "mainImage"
                                      )
                                    }
                                  />
                                  <button
                                    onClick={(e) => {
                                      upload(
                                        `${directory && directory.id}` + 30
                                      );
                                    }}
                                    className="middle_Icon button-18"
                                  >
                                    Upload
                                  </button>
                                </>
                              ) : (
                                <button
                                  className="middle_Icon button-18"
                                  onClick={() => {
                                    setDeleteItem({
                                      directory,
                                      selection: "directory",
                                      checkImage: "mainImage",
                                    });
                                    setShowDelete(true);
                                  }}
                                >
                                  Remove
                                </button>
                              )}
                            </div>
                          </Col>
                        )} */}

                      <Col
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="directoryHeader1 m-0"
                      >
                        <div>
                          <p>Retreat Directory</p>
                          <h2> {data?.myparish?.parish}</h2>
                          <h1 className="mt-2 m-0">
                            {data.dateFrom && data.dateTo ? (
                              <span>
                                {moment(data.dateFrom).isSame(
                                  data.dateTo,
                                  "day",
                                )
                                  ? // Same day
                                  `${moment(data.dateFrom)
                                    .tz("America/New_York")
                                    .format("MMM D, YYYY")}`
                                  : moment(data.dateFrom).isSame(
                                    data.dateTo,
                                    "month",
                                  )
                                    ? // Same month, show month only once
                                    `${moment(data.dateFrom)
                                      .tz("America/New_York")
                                      .format("MMM D")} - ${moment(
                                        data.dateTo,
                                      )
                                        .tz("America/New_York")
                                        .format("D")}, ${moment(data.dateFrom)
                                          .tz("America/New_York")
                                          .format("YYYY")}`
                                    : // Different months
                                    `${moment(data.dateFrom)
                                      .tz("America/New_York")
                                      .format("MMM D")} - ${moment(
                                        data.dateTo,
                                      )
                                        .tz("America/New_York")
                                        .format("MMM D")}, ${moment(
                                          data.dateFrom,
                                        )
                                          .tz("America/New_York")
                                          .format("YYYY")}`}
                              </span>
                            ) : null}
                          </h1>
                        </div>
                      </Col>
                      {(allRetreatRoasters &&
                        allRetreatRoasters[0] &&
                        allRetreatRoasters[0].lead &&
                        allRetreatRoasters[0].lead.length) ||
                        (allRetreatRoasters &&
                          allRetreatRoasters[1] &&
                          allRetreatRoasters[1].coLead &&
                          allRetreatRoasters[1].coLead.length) ||
                        (allRetreatRoasters &&
                          allRetreatRoasters[2] &&
                          allRetreatRoasters[2].mentor &&
                          allRetreatRoasters[2].mentor.length) ||
                        (allRetreatRoasters &&
                          allRetreatRoasters[4] &&
                          allRetreatRoasters[4].sprDirector &&
                          allRetreatRoasters[4].sprDirector.length) ||
                        (allRetreatRoasters &&
                          allRetreatRoasters[3] &&
                          allRetreatRoasters[3].sprAdvisor &&
                          allRetreatRoasters[3].sprAdvisor.length) ? (
                        <Col
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          className="colorTalks mt-3 p-5 leaderShip text-center"
                        >
                          <h2 className="LeadHeading">Leadership</h2>
                          {allRetreatRoasters &&
                            allRetreatRoasters[0] &&
                            allRetreatRoasters[0].lead &&
                            allRetreatRoasters[0].lead.map((item, i) => {
                              <h3>Lead Couple</h3>;
                              return (
                                <Row key={i} className="mt-4">
                                  <Col
                                    md={5}
                                    className="coupleImages coupleImageHower mainHeaderImage"
                                  >
                                    {(item && item.imageUrl == "") ||
                                      item.imageUrl == undefined ? (
                                      <div className="edit-profile-img mb-2  imageHeader mt-3">
                                        <img
                                          src={Profile}
                                          className="shadowImage"
                                        />
                                      </div>
                                    ) : (
                                      <div className="edit-profile-img mb-2  imageHeader mt-3">
                                          <img
                                            src={item && item.imageUrl}
                                            className="shadowImage profileImage"
                                            loading="lazy"
                                          />
                                      </div>
                                    )}{" "}
                                    <div className="text-center setUploadField">
                                      {(item && item.imageUrl == "") ||
                                        item.imageUrl == undefined ? (
                                        <>
                                          <input
                                            name="imageUrl"
                                            className="pt-1"
                                            type="file"
                                            accept="image/*"
                                            style={{
                                              display: "none",
                                            }}
                                            id={
                                              `${i}` +
                                              "-" +
                                              "CoupleProfileUpload"
                                            }
                                            onChange={(e) =>
                                              handleImageChanges(e, item)
                                            }
                                          />
                                          <i
                                            onClick={(e) => {
                                              upload(i);
                                            }}
                                            className="mdi mdi-upload text-lg text-primary font-size middle_Icon1"
                                            title="Image Upload"
                                          ></i>
                                        </>
                                      ) : (
                                        <i
                                          className="mdi mdi-delete-circle text-md text-danger mx-2 font-size middle_Icon1"
                                          onClick={(e) => {
                                            setDeleteItem({
                                              directory: item,
                                              selection: "",
                                              checkImage: "",
                                            });
                                            setShowDelete(true);
                                          }}
                                          title="Remove"
                                        ></i>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={7} className="coupl_detail">
                                    {i === 0 ? (
                                      <h4 className="mt-3">Lead Couple</h4>
                                    ) : null}
                                    <h2
                                      className="mt-3 mb-3"
                                      onClick={() => openCoupleUpdate(item)}
                                      style={{ cursor: "pointer" }}
                                      title="Update Couple Information"
                                    >
                                      {`${item?.hisFirstName
                                        ? item.hisFirstName
                                        : ""
                                        }${item?.hisFirstName && item?.herFirstName
                                          ? " & "
                                          : ""
                                        }${item?.herFirstName
                                          ? item.herFirstName
                                          : ""
                                        } ${item?.hisLastName
                                          ? item.hisLastName
                                          : item?.herLastName
                                            ? item.herLastName
                                            : ""
                                        }`}
                                    </h2>

                                    {(item?.hisMobile || item?.hisEmail) && (
                                      <>
                                        <h4>
                                          His:{" "}
                                          {item.hisMobile ? item.hisMobile : ""}
                                        </h4>
                                        {item.hisEmail && (
                                          <h4>{item.hisEmail}</h4>
                                        )}
                                      </>
                                    )}

                                    {(item?.herMobile || item?.herEmail) && (
                                      <>
                                        <h4>
                                          Hers:{" "}
                                          {item.herMobile ? item.herMobile : ""}
                                        </h4>
                                        {item.herEmail && (
                                          <h4>{item.herEmail}</h4>
                                        )}
                                      </>
                                    )}

                                    {item && item.anniversary_date ? (
                                      <h4>
                                        {"Anniversary Date : " +
                                          `${item && item.anniversary_date
                                            ? Helpers.convertUtcToTimezone(
                                              item.anniversary_date,
                                              "MM/DD",
                                            )
                                            : ""
                                          }`}
                                      </h4>
                                    ) : (
                                      ""
                                    )}
                                  </Col>
                                </Row>
                              );
                            })}

                          {allRetreatRoasters &&
                            allRetreatRoasters[1] &&
                            allRetreatRoasters[1].coLead &&
                            allRetreatRoasters[1].coLead.map((item, i) => {
                              return (
                                <Row key={i} className="mt-4">
                                  <Col
                                    md={5}
                                    className="coupleImages coupleImageHower mainHeaderImage"
                                  >
                                    {(item && item.imageUrl == "") ||
                                      item.imageUrl == undefined ? (
                                      <div className="edit-profile-img mb-2  imageHeader mt-3">
                                        <img
                                          src={Profile}
                                          className="shadowImage"
                                        />
                                      </div>
                                    ) : (
                                      <div className="edit-profile-img mb-2  imageHeader mt-3">
                                          <img
                                            src={item && item.imageUrl}
                                            className="shadowImage profileImage"
                                            loading="lazy"
                                          />
                                      </div>
                                    )}{" "}
                                    <div className="text-center setUploadField">
                                      {(item && item.imageUrl == "") ||
                                        item.imageUrl == undefined ? (
                                        <>
                                          <input
                                            name="imageUrl"
                                            className="pt-1"
                                            type="file"
                                            accept="image/*"
                                            style={{
                                              display: "none",
                                            }}
                                            id={
                                              `${i}` +
                                              "-" +
                                              "CoupleProfileUpload"
                                            }
                                            onChange={(e) =>
                                              handleImageChanges(e, item)
                                            }
                                          />
                                          <i
                                            onClick={(e) => {
                                              upload(i);
                                            }}
                                            className="mdi mdi-upload text-lg text-primary font-size middle_Icon1"
                                            title="Image Upload"
                                          ></i>
                                        </>
                                      ) : (
                                        <i
                                          className="mdi mdi-delete-circle text-md text-danger mx-2 font-size middle_Icon1"
                                          onClick={() => {
                                            setDeleteItem({
                                              directory: item,
                                              selection: "",
                                              checkImage: "",
                                            });
                                            setShowDelete(true);
                                          }}
                                          title="Remove"
                                        ></i>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={7} className="coupl_detail">
                                    {i === 0 ? (
                                      <h4 className="mt-3">Co-Lead Couple</h4>
                                    ) : null}
                                    <h2
                                      className="mt-3 mb-3"
                                      onClick={() => openCoupleUpdate(item)}
                                      style={{ cursor: "pointer" }}
                                      title="Update Couple Information"
                                    >
                                      {`${item?.hisFirstName
                                        ? item.hisFirstName
                                        : ""
                                        }${item?.hisFirstName && item?.herFirstName
                                          ? " & "
                                          : ""
                                        }${item?.herFirstName
                                          ? item.herFirstName
                                          : ""
                                        } ${item?.hisLastName
                                          ? item.hisLastName
                                          : item?.herLastName
                                            ? item.herLastName
                                            : ""
                                        }`}
                                    </h2>

                                    {(item?.hisMobile || item?.hisEmail) && (
                                      <>
                                        <h4>
                                          His:{" "}
                                          {item.hisMobile ? item.hisMobile : ""}
                                        </h4>
                                        {item.hisEmail && (
                                          <h4>{item.hisEmail}</h4>
                                        )}
                                      </>
                                    )}

                                    {(item?.herMobile || item?.herEmail) && (
                                      <>
                                        <h4>
                                          Hers:{" "}
                                          {item.herMobile ? item.herMobile : ""}
                                        </h4>
                                        {item.herEmail && (
                                          <h4>{item.herEmail}</h4>
                                        )}
                                      </>
                                    )}
                                    {item && item.anniversary_date ? (
                                      <h4>
                                        {" "}
                                        {"Anniversary Date : " +
                                          `${item && item.anniversary_date
                                            ? Helpers.convertUtcToTimezone(
                                              item.anniversary_date,
                                              "MM/DD",
                                            )
                                            : ""
                                          }`}
                                      </h4>
                                    ) : (
                                      ""
                                    )}
                                  </Col>
                                </Row>
                              );
                            })}

                          {allRetreatRoasters &&
                            allRetreatRoasters[2] &&
                            allRetreatRoasters[2].mentor &&
                            allRetreatRoasters[2].mentor.map((item, i) => {
                              return (
                                <Row key={i} className="my-5">
                                  <Col
                                    md={5}
                                    className="coupleImages coupleImageHower mainHeaderImage"
                                  >
                                    {(item && item.imageUrl == "") ||
                                      item.imageUrl == undefined ? (
                                      <div className="edit-profile-img mb-2  imageHeader mt-3">
                                        <img
                                          src={Profile}
                                          className="shadowImage"
                                        />
                                      </div>
                                    ) : (
                                      <div className="edit-profile-img mb-2  imageHeader mt-3">
                                          <img
                                            src={item && item.imageUrl}
                                            className="shadowImage profileImage"
                                            loading="lazy"
                                          />
                                      </div>
                                    )}{" "}
                                    <div className="text-center setUploadField">
                                      {(item && item.imageUrl == "") ||
                                        item.imageUrl == undefined ? (
                                        <>
                                          <input
                                            name="imageUrl"
                                            className="pt-1"
                                            type="file"
                                            accept="image/*"
                                            style={{
                                              display: "none",
                                            }}
                                            id={
                                              `${i}` +
                                              "-" +
                                              "CoupleProfileUpload"
                                            }
                                            onChange={(e) =>
                                              handleImageChanges(e, item)
                                            }
                                          />
                                          <i
                                            onClick={(e) => {
                                              upload(i);
                                            }}
                                            className="mdi mdi-upload text-lg text-primary font-size middle_Icon1"
                                            title="Image Upload"
                                          ></i>
                                        </>
                                      ) : (
                                        <i
                                          className="mdi mdi-delete-circle text-md text-danger mx-2 font-size middle_Icon1"
                                          onClick={() => {
                                            setDeleteItem({
                                              directory: item,
                                              selection: "",
                                              checkImage: "",
                                            });
                                            setShowDelete(true);
                                          }}
                                          title="Remove"
                                        ></i>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={7} className="coupl_detail">
                                    {i === 0 ? (
                                      <h4 className="mt-3">Mentor Couple</h4>
                                    ) : null}
                                    <h2
                                      className="mt-3 mb-3"
                                      onClick={() => openCoupleUpdate(item)}
                                      style={{ cursor: "pointer" }}
                                      title="Update Couple Information"
                                    >
                                      {`${item?.hisFirstName
                                        ? item.hisFirstName
                                        : ""
                                        }${item?.hisFirstName && item?.herFirstName
                                          ? " & "
                                          : ""
                                        }${item?.herFirstName
                                          ? item.herFirstName
                                          : ""
                                        } ${item?.hisLastName
                                          ? item.hisLastName
                                          : item?.herLastName
                                            ? item.herLastName
                                            : ""
                                        }`}
                                    </h2>

                                    {(item?.hisMobile || item?.hisEmail) && (
                                      <>
                                        <h4>
                                          His:{" "}
                                          {item.hisMobile ? item.hisMobile : ""}
                                        </h4>
                                        {item.hisEmail && (
                                          <h4>{item.hisEmail}</h4>
                                        )}
                                      </>
                                    )}

                                    {(item?.herMobile || item?.herEmail) && (
                                      <>
                                        <h4>
                                          Hers:{" "}
                                          {item.herMobile ? item.herMobile : ""}
                                        </h4>
                                        {item.herEmail && (
                                          <h4>{item.herEmail}</h4>
                                        )}
                                      </>
                                    )}
                                    {item && item.anniversary_date ? (
                                      <h4>
                                        {" "}
                                        {"Anniversary Date : " +
                                          `${item && item.anniversary_date
                                            ? Helpers.convertUtcToTimezone(
                                              item.anniversary_date,
                                              "MM/DD",
                                            )
                                            : ""
                                          }`}
                                      </h4>
                                    ) : (
                                      ""
                                    )}
                                  </Col>
                                </Row>
                              );
                            })}
                          {allRetreatRoasters &&
                            allRetreatRoasters[3] &&
                            allRetreatRoasters[3].sprAdvisor &&
                            allRetreatRoasters[3].sprAdvisor.map((item, i) => {
                              return (
                                <Row key={i} className="my-5">
                                  <Col
                                    md={5}
                                    className="coupleImages coupleImageHower mainHeaderImage"
                                  >
                                    {(item && item.imageUrl == "") ||
                                      item.imageUrl == undefined ? (
                                      <div className="edit-profile-img mb-2  imageHeader mt-3">
                                        <img
                                          src={Profile}
                                          className="shadowImage"
                                        />
                                      </div>
                                    ) : (
                                      <div className="edit-profile-img mb-2  imageHeader mt-3">
                                          <img
                                            src={item && item.imageUrl}
                                            className="shadowImage profileImage"
                                            loading="lazy"
                                          />
                                      </div>
                                    )}{" "}
                                    <div className="text-center setUploadField">
                                      {(item && item.imageUrl == "") ||
                                        item.imageUrl == undefined ? (
                                        <>
                                          <input
                                            name="imageUrl"
                                            className="pt-1"
                                            type="file"
                                            accept="image/*"
                                            style={{
                                              display: "none",
                                            }}
                                            id={
                                              `${i}` +
                                              "-" +
                                              "CoupleProfileUpload"
                                            }
                                            onChange={(e) =>
                                              handleImageChanges(e, item)
                                            }
                                          />
                                          <i
                                            onClick={(e) => {
                                              upload(i);
                                            }}
                                            className="mdi mdi-upload text-lg text-primary font-size middle_Icon1"
                                            title="Image Upload"
                                          ></i>
                                        </>
                                      ) : (
                                        <i
                                          className="mdi mdi-delete-circle text-md text-danger mx-2 font-size middle_Icon1"
                                          onClick={() => {
                                            setDeleteItem({
                                              directory: item,
                                              selection: "",
                                              checkImage: "",
                                            });
                                            setShowDelete(true);
                                          }}
                                          title="Remove"
                                        ></i>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={7} className="coupl_detail">
                                    {i === 0 ? (
                                      <h4 className="mt-3">Spiritual Mentor</h4>
                                    ) : null}

                                    <h2
                                      className="mt-3 mb-3"
                                      onClick={() => openCoupleUpdate(item)}
                                      style={{ cursor: "pointer" }}
                                      title="Update Couple Information"
                                    >
                                      {item?.hisFirstName && item?.herFirstName
                                        ? `${item.hisFirstName} & ${item.herFirstName} ${item.hisLastName || ""}`
                                        : item?.hisFirstName
                                          ? `${item.hisFirstName} ${item.hisLastName || ""}`
                                          : item?.herFirstName
                                            ? `${item.herFirstName} ${item.herLastName || ""}`
                                            : ""}
                                    </h2>

                                    {/* Check if BOTH exist */}
                                    {item?.hisFirstName &&
                                      item?.herFirstName ? (
                                      <>
                                        {(item?.hisMobile ||
                                          item?.hisEmail) && (
                                            <>
                                              <h4>His: {item.hisMobile || ""}</h4>
                                              {item.hisEmail && (
                                                <h4>{item.hisEmail}</h4>
                                              )}
                                            </>
                                          )}

                                        {(item?.herMobile ||
                                          item?.herEmail) && (
                                            <>
                                              <h4>Hers: {item.herMobile || ""}</h4>
                                              {item.herEmail && (
                                                <h4>{item.herEmail}</h4>
                                              )}
                                            </>
                                          )}
                                      </>
                                    ) : (
                                      <>
                                        {/* Only one exists → NO His/Her label */}
                                        {(item?.hisMobile ||
                                          item?.hisEmail) && (
                                            <>
                                              <h4>{item.hisMobile || ""}</h4>
                                              {item.hisEmail && (
                                                <h4>{item.hisEmail}</h4>
                                              )}
                                            </>
                                          )}

                                        {(item?.herMobile ||
                                          item?.herEmail) && (
                                            <>
                                              <h4>{item.herMobile || ""}</h4>
                                              {item.herEmail && (
                                                <h4>{item.herEmail}</h4>
                                              )}
                                            </>
                                          )}
                                      </>
                                    )}

                                    {item?.anniversary_date && (
                                      <h4>
                                        {"Anniversary Date : " +
                                          Helpers.convertUtcToTimezone(
                                            item.anniversary_date,
                                            "MM/DD",
                                          )}
                                      </h4>
                                    )}
                                  </Col>
                                </Row>
                              );
                            })}
                          {allRetreatRoasters &&
                            allRetreatRoasters[4] &&
                            allRetreatRoasters[4].sprDirector &&
                            allRetreatRoasters[4].sprDirector.map((item, i) => {
                              return (
                                <Row key={i} className="my-5">
                                  <Col
                                    md={5}
                                    className="coupleImages coupleImageHower mainHeaderImage"
                                  >
                                    {(item && item.priestImage == "") ||
                                      item.priestImage == undefined ? (
                                      <div className="edit-profile-img mb-2  imageHeader mt-3">
                                        <img
                                          src={priestProfile}
                                          className="shadowImage profileImage"
                                        />
                                      </div>
                                    ) : (
                                      <div className="edit-profile-img mb-2  imageHeader mt-3">
                                          <img
                                            src={item && item.priestImage}
                                            className="shadowImage profileImage"
                                            
                                            
                                          />
                                      </div>
                                    )}{" "}
                                    <div className="text-center setUploadField">
                                      {(item && item.priestImage == "") ||
                                        item.priestImage == undefined ? (
                                        <>
                                          <input
                                            name="imageUrl"
                                            className="pt-1"
                                            type="file"
                                            accept="image/*"
                                            style={{
                                              display: "none",
                                            }}
                                            id={
                                              `${i}` +
                                              "-" +
                                              "CoupleProfileUpload"
                                            }
                                            onChange={(e) =>
                                              handleImageChanges(
                                                e,
                                                item,
                                                "sprDirector",
                                              )
                                            }
                                          />
                                          <i
                                            onClick={(e) => {
                                              upload(i);
                                            }}
                                            className="mdi mdi-upload text-lg text-primary font-size middle_Icon1"
                                            title="Image Upload"
                                          ></i>
                                        </>
                                      ) : (
                                        <i
                                          className="mdi mdi-delete-circle text-md text-danger mx-2 font-size middle_Icon1"
                                          onClick={() => {
                                            setDeleteItem({
                                              directory: item,
                                              selection: "priest",
                                              checkImage: "priest",
                                            });
                                            setShowDelete(true);
                                          }}
                                          title="Remove"
                                        ></i>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={7} className="coupl_detail">
                                    {i === 0 && (
                                      <h4 className="mt-3">
                                        Spiritual Director
                                      </h4>
                                    )}
                                    <h2
                                      className="mt-3 mb-3"
                                      onClick={() => openPriestUpdate(item)}
                                      style={{ cursor: "pointer" }}
                                      title="Update Priest Information"
                                    >
                                      {[
                                        item?.priestTitle,
                                        item?.priestFirstName,
                                        item?.priestLastName,
                                      ]
                                        .filter(Boolean)
                                        .join(" ")}
                                    </h2>
                                    {/* {item?.email && (
                                      <>
                                        <h4>
                                          Email: {item.email ? item.email : ""}
                                        </h4>
                                      </>
                                    )} */}
                                  </Col>
                                </Row>
                              );
                            })}
                        </Col>
                      ) : null}
                      {allRetreatRoasters &&
                        allRetreatRoasters[6] &&
                        allRetreatRoasters[6].retreatant.length &&
                        allRetreatRoasters[6].retreatant ? (
                        <Col
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          className="colorTalks mt-2 p-5 leaderShip text-center"
                        >
                          <img
                            src={lovestrongLogo}
                            alt=""
                            srcSet=""
                            style={{
                              height: "90px",
                            }}
                          />

                          <h2 className="LeadHeading mt-4">Retreatants</h2>
                          {allRetreatRoasters &&
                            allRetreatRoasters[6] &&
                            allRetreatRoasters[6].retreatant &&
                            allRetreatRoasters[6].retreatant.map((item, i) => {
                              return (
                                <Row className="mt-4" key={i}>
                                  <Col
                                    md={5}
                                    className="coupleImages coupleImageHower mainHeaderImage"
                                  >
                                    {(item && item.imageUrl == "") ||
                                      item.imageUrl == undefined ? (
                                      <div className="edit-profile-img mb-2  imageHeader mt-3">
                                        <img
                                          src={Profile}
                                          className="shadowImage"
                                        />
                                      </div>
                                    ) : (
                                      <div className="edit-profile-img mb-2  imageHeader mt-3 ">
                                        <>
                                          <img
                                            src={item && item.imageUrl}
                                            className="shadowImage profileImage"
                                            onError={(e) => {
                                              e.target.onerror = null;
                                              e.target.src = corruptedImg;
                                            }}
                                          />
                                        </>{" "}
                                      </div>
                                    )}{" "}
                                    <div className="text-center setUploadField">
                                      {(item && item.imageUrl == "") ||
                                        item.imageUrl == undefined ? (
                                        <>
                                          <input
                                            name="imageUrl"
                                            className="pt-1"
                                            type="file"
                                            accept="image/*"
                                            style={{
                                              display: "none",
                                            }}
                                            id={
                                              `${i}` +
                                              "-" +
                                              "CoupleProfileUpload"
                                            }
                                            onChange={(e) =>
                                              handleImageChanges(e, item)
                                            }
                                          />
                                          <i
                                            onClick={(e) => {
                                              upload(i);
                                            }}
                                            className="mdi mdi-upload text-lg text-primary font-size middle_Icon1"
                                            title="Image Upload"
                                          ></i>
                                        </>
                                      ) : (
                                        <i
                                          className="mdi mdi-delete-circle text-md text-danger mx-2 font-size middle_Icon1"
                                          onClick={() => {
                                            setDeleteItem({
                                              directory: item,
                                              selection: "",
                                              checkImage: "",
                                            });
                                            setShowDelete(true);
                                          }}
                                          title="Remove"
                                        ></i>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={7} className="coupl_detail">
                                    {" "}
                                    <h2
                                      className="mt-3 mb-3"
                                      onClick={() => openCoupleUpdate(item)}
                                      style={{ cursor: "pointer" }}
                                      title="Update Couple Information"
                                    >
                                      {`${item?.hisFirstName
                                        ? item.hisFirstName
                                        : ""
                                        }${item?.hisFirstName && item?.herFirstName
                                          ? " & "
                                          : ""
                                        }${item?.herFirstName
                                          ? item.herFirstName
                                          : ""
                                        } ${item?.hisLastName
                                          ? item.hisLastName
                                          : item?.herLastName
                                            ? item.herLastName
                                            : ""
                                        }`}
                                    </h2>
                                    {(item?.hisMobile || item?.hisEmail) && (
                                      <>
                                        <h4>
                                          His:{" "}
                                          {item.hisMobile ? item.hisMobile : ""}
                                        </h4>
                                        {item.hisEmail && (
                                          <h4>{item.hisEmail}</h4>
                                        )}
                                      </>
                                    )}
                                    {(item?.herMobile || item?.herEmail) && (
                                      <>
                                        <h4>
                                          Hers:{" "}
                                          {item.herMobile ? item.herMobile : ""}
                                        </h4>
                                        {item.herEmail && (
                                          <h4>{item.herEmail}</h4>
                                        )}
                                      </>
                                    )}
                                    {item && item.anniversary_date ? (
                                      <h4>
                                        {" "}
                                        {"Anniversary Date : " +
                                          `${item && item.anniversary_date
                                            ? Helpers.convertUtcToTimezone(
                                              item.anniversary_date,
                                              "MM/DD",
                                            )
                                            : ""
                                          }`}
                                      </h4>
                                    ) : (
                                      ""
                                    )}
                                  </Col>
                                </Row>
                              );
                            })}
                        </Col>
                      ) : null}

                      {allRetreatRoasters &&
                        allRetreatRoasters[5] &&
                        allRetreatRoasters[5].team &&
                        allRetreatRoasters[5].team.length ? (
                        <Col
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          className="colorTalks mt-3 p-5 leaderShip text-center"
                        >
                          {" "}
                          <img
                            src={lovestrongLogo}
                            alt=""
                            srcSet=""
                            style={{
                              height: "90px",
                            }}
                          />
                          <h2 className="LeadHeading mt-4">Team</h2>
                          {allRetreatRoasters &&
                            allRetreatRoasters[5] &&
                            allRetreatRoasters[5].team &&
                            allRetreatRoasters[5].team.map((item, i) => {
                              return (
                                <Row className="mt-4">
                                  <Col
                                    md={5}
                                    className="coupleImages coupleImageHower mainHeaderImage"
                                  >
                                    {(item && item.imageUrl == "") ||
                                      item.imageUrl == undefined ? (
                                      <div className="edit-profile-img mt-4 mb-2 imageHeader">
                                        <img
                                          src={Profile}
                                          className="shadowImage"
                                        />
                                      </div>
                                    ) : (
                                      <div className="edit-profile-img mb-2 imageHeader">
                                        <>
                                          <img
                                            src={item && item.imageUrl}
                                            className="shadowImage profileImage"
                                            onError={(e) => {
                                              e.target.onerror = null;
                                              e.target.src = corruptedImg;
                                            }}
                                          />
                                        </>{" "}
                                      </div>
                                    )}{" "}
                                    <div className="text-center setUploadField">
                                      {(item && item.imageUrl == "") ||
                                        item.imageUrl == undefined ? (
                                        <>
                                          <input
                                            name="imageUrl"
                                            className="pt-1"
                                            type="file"
                                            accept="image/*"
                                            style={{
                                              display: "none",
                                            }}
                                            id={
                                              `${i}` +
                                              "-" +
                                              "CoupleProfileUpload"
                                            }
                                            onChange={(e) =>
                                              handleImageChanges(e, item)
                                            }
                                          />
                                          <i
                                            onClick={(e) => {
                                              upload(i);
                                            }}
                                            className="mdi mdi-upload text-lg text-primary font-size middle_Icon1"
                                            title="Image Upload"
                                          ></i>
                                        </>
                                      ) : (
                                        <i
                                          className="mdi mdi-delete-circle text-md text-danger mx-2 font-size middle_Icon1"
                                          onClick={() => {
                                            setDeleteItem({
                                              directory: item,
                                              selection: "",
                                              checkImage: "",
                                            });
                                            setShowDelete(true);
                                          }}
                                          title="Remove"
                                        ></i>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={7} className="coupl_detail">
                                    {" "}
                                    <h2
                                      className="mt-3 mb-3"
                                      onClick={() => openCoupleUpdate(item)}
                                      style={{ cursor: "pointer" }}
                                      title="Update Couple Information"
                                    >
                                      {`${item?.hisFirstName
                                        ? item.hisFirstName
                                        : ""
                                        }${item?.hisFirstName && item?.herFirstName
                                          ? " & "
                                          : ""
                                        }${item?.herFirstName
                                          ? item.herFirstName
                                          : ""
                                        } ${item?.hisLastName
                                          ? item.hisLastName
                                          : item?.herLastName
                                            ? item.herLastName
                                            : ""
                                        }`}
                                    </h2>
                                    {(item?.hisMobile || item?.hisEmail) && (
                                      <>
                                        <h4>
                                          His:{" "}
                                          {item.hisMobile ? item.hisMobile : ""}
                                        </h4>
                                        {item.hisEmail && (
                                          <h4>{item.hisEmail}</h4>
                                        )}
                                      </>
                                    )}
                                    {(item?.herMobile || item?.herEmail) && (
                                      <>
                                        <h4>
                                          Hers:{" "}
                                          {item.herMobile ? item.herMobile : ""}
                                        </h4>
                                        {item.herEmail && (
                                          <h4>{item.herEmail}</h4>
                                        )}
                                      </>
                                    )}
                                    {item && item.anniversary_date ? (
                                      <h4>
                                        {" "}
                                        {"Anniversary Date : " +
                                          `${item && item.anniversary_date
                                            ? Helpers.convertUtcToTimezone(
                                              item.anniversary_date,
                                              "MM/DD",
                                            )
                                            : ""
                                          }`}
                                      </h4>
                                    ) : (
                                      ""
                                    )}
                                  </Col>
                                </Row>
                              );
                            })}
                        </Col>
                      ) : null}

                      <Col
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="colorTalks mt-3 leaderShip"
                      >
                        {loadFooter ? (
                          <div className="mainHeaderImage">
                            {" "}
                            <Row className="text-center">
                              <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className=" mt-3 p-5"
                              >
                                <Loader />
                              </Col>
                            </Row>
                          </div>
                        ) : (
                          <div>
                            {/* Display all footer images */}
                            {directory &&
                              directory.footerImages &&
                              directory.footerImages.length > 0 &&
                              directory.footerImages.map(
                                (footerImg, imgIndex) => (
                                  <div
                                    key={imgIndex}
                                    className="mb-2 text-center footer_images mainHeaderImage"
                                    style={{
                                      position: "relative",
                                      display: "inline-block",
                                      width: "100%",
                                    }}
                                  >
                                    <img
                                      src={footerImg}
                                      className="imageHeader"
                                      alt={`Footer ${imgIndex + 1}`}
                                      
                                    />
                                    {/* Delete button in center of image - shows on hover */}
                                    <button
                                      className="middle_Icon button-18"
                                      onClick={(e) => {
                                        // Check if this is the last image
                                        if (
                                          directory.footerImages.length <= 1
                                        ) {
                                          toast.error(
                                            "At least one footer image is required. Cannot remove the last image.",
                                          );
                                          return;
                                        }
                                        // Show delete alert
                                        setDeleteItem({
                                          directory,
                                          selection: "directory",
                                          checkImage: "footerImage",
                                          imageIndex: imgIndex,
                                        });
                                        setShowDelete(true);
                                      }}
                                      style={{
                                        backgroundColor:
                                          "rgba(220, 53, 69, 0.9)",
                                        color: "white",
                                        border: "none",
                                        padding: "8px 16px",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Delete
                                    </button>
                                  </div>
                                ),
                              )}

                            {/* Dummy image placeholder with "Add image" button */}
                            <div
                              className="mb-2 text-center footer_images mainHeaderImage"
                              style={{
                                position: "relative",
                                display: "inline-block",
                                width: "100%",
                              }}
                            >
                              <img
                                src={ImagePlaceHolder}
                                alt=""
                                srcSet=""
                                className="imageHeader"
                              />
                              {/* Add image button in center - shows on hover */}
                              <input
                                name="imageUrl"
                                className="pt-1"
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                id={
                                  `${directory && directory.id}` +
                                  40 +
                                  "-" +
                                  "CoupleProfileUpload"
                                }
                                onChange={(e) =>
                                  handleallImagesChanges(
                                    e,
                                    directory,
                                    "footerImage",
                                  )
                                }
                              />
                              <button
                                onClick={(e) => {
                                  upload(`${directory && directory.id}` + 40);
                                }}
                                className="middle_Icon button-18"
                                style={{
                                  backgroundColor: "rgba(0, 123, 255, 0.9)",
                                  color: "white",
                                  border: "none",
                                  padding: "8px 16px",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                Add Image
                              </button>
                            </div>
                          </div>
                        )}
                        <div className="retdet text-center">
                          <div>
                            {" "}
                            <h2>{data?.myparish?.parish} Lovestrong Retreat</h2>
                            <h1>
                              {data.dateFrom && data.dateTo ? (
                                <span>
                                  {moment(data.dateFrom).isSame(
                                    data.dateTo,
                                    "day",
                                  )
                                    ? // Same day
                                    `${moment(data.dateFrom)
                                      .tz("America/New_York")
                                      .format("MMM D, YYYY")}`
                                    : moment(data.dateFrom).isSame(
                                      data.dateTo,
                                      "month",
                                    )
                                      ? // Same month, show month only once
                                      `${moment(data.dateFrom)
                                        .tz("America/New_York")
                                        .format("MMM D")} - ${moment(
                                          data.dateTo,
                                        )
                                          .tz("America/New_York")
                                          .format("D")}, ${moment(data.dateFrom)
                                            .tz("America/New_York")
                                            .format("YYYY")}`
                                      : // Different months
                                      `${moment(data.dateFrom)
                                        .tz("America/New_York")
                                        .format("MMM D")} - ${moment(
                                          data.dateTo,
                                        )
                                          .tz("America/New_York")
                                          .format("MMM D")}, ${moment(
                                            data.dateFrom,
                                          )
                                            .tz("America/New_York")
                                            .format("YYYY")}`}
                                </span>
                              ) : null}
                            </h1>
                          </div>
                        </div>{" "}
                        <div className="directory-footer-block mt-3">
                          <div className="directory-footer-toolbar">
                            <div>
                              <h3>Footer Text</h3>
                              <p>
                                This text appears at the bottom of the Directory.
                              </p>
                            </div>
                            <button
                              type="button"
                              className="button-18"
                              onClick={() => hadleDirectoryModel()}
                            >
                              <i className="mdi mdi-pencil" aria-hidden="true"></i>
                              {directory && directory.footerText
                                ? "Edit Footer Text"
                                : "Add Footer Text"}
                            </button>
                          </div>
                          <div
                            className="directory-footer-preview"
                            role="button"
                            tabIndex={0}
                            onClick={() => hadleDirectoryModel()}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                hadleDirectoryModel();
                              }
                            }}
                          >
                            {directory && directory.footerText ? (
                              <div
                                className="footerTitle"
                                dangerouslySetInnerHTML={{
                                  __html: directory.footerText,
                                }}
                              />
                            ) : (
                              <p className="directory-footer-placeholder">
                                Click Edit Footer Text to add the wording that
                                shows at the bottom of the Directory.
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="social-icons" onClick={socialLinksOpen}>
                          <i className="mdi mdi-facebook"></i>

                          <i className="mdi mdi-twitter"></i>

                          <i className="mdi mdi-pinterest"></i>

                          <i className="mdi mdi-instagram"></i>
                        </div>
                        <div className="text-center">
                          {" "}
                          <img
                            src={lovestrongLogo}
                            alt=""
                            srcSet=""
                            className="logo_image footer-logo-image1"
                          />
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </div>
            </div>
          </div>
        </div>

        {modalShow ? (
          <DirectoryModel
            show={modalShow}
            directory={directory}
            retreatData={data}
            coupleTalkData={coupleTalkData}
            onHide={() => closeDirectoryModel()}
          />
        ) : null}

        <DeleteModel
          show={showDelete}
          content={
            <>
              {deleteItem?.checkImage === "mainImage" ? (
                <>
                  <h5 className="mt-4 fw-bold">Directory Header image</h5>
                  <div className="p-3 border rounded-3 bg-light shadow-sm">
                    This action will permanently remove the image.
                  </div>
                </>
              ) : deleteItem?.checkImage === "footerImage" ? (
                <>
                  <h5 className="mt-4 fw-bold">Directory Footer image</h5>
                  <div className="p-3 border rounded-3 bg-light shadow-sm">
                    {deleteItem?.directory?.footerImages &&
                      deleteItem?.directory?.footerImages.length <= 1 ? (
                      <div className="text-danger">
                        <strong>Warning:</strong> This is the last footer image.
                        At least one footer image is required. This action
                        cannot be completed.
                      </div>
                    ) : (
                      "This action will permanently remove the image."
                    )}
                  </div>
                </>
              ) : deleteItem?.checkImage === "priest" ? (
                <>
                  <h5 className="mt-4 fw-bold">Spiritual Director Detail: </h5>
                  <div className="p-3 border rounded-3 bg-light shadow-sm">
                    {/* His Details */}
                    {(deleteItem?.directory?.priestFirstName ||
                      deleteItem?.directory?.priestEmail) && (
                        <div className="mb-2">
                          <span className="fw-bold">Name :</span>{" "}
                          {[
                            deleteItem?.directory?.priestTitle,
                            deleteItem?.directory?.priestFirstName,
                            deleteItem?.directory?.priestLastName,
                          ]
                            .filter(Boolean)
                            .join(" ")}
                          {deleteItem?.directory?.priestEmail && (
                            <span className="text-muted">
                              {" "}
                              – {deleteItem?.directory?.priestEmail}
                            </span>
                          )}
                        </div>
                      )}
                  </div>
                </>
              ) : (
                <>
                  <h5 className="mt-4 fw-bold">Couple Detail: </h5>
                  <div className="p-3 border rounded-3 bg-light shadow-sm">
                    {/* His Details */}
                    {(deleteItem?.directory?.hisFirstName ||
                      deleteItem?.directory?.hisLastName ||
                      deleteItem?.directory?.hisEmail) && (
                        <div className="mb-2">
                          <span className="fw-bold">His:</span>{" "}
                          {deleteItem?.directory?.hisFirstName}{" "}
                          {deleteItem?.directory?.hisLastName}
                          {deleteItem?.directory?.hisEmail && (
                            <span className="text-muted">
                              {" "}
                              – {deleteItem?.directory?.hisEmail}
                            </span>
                          )}
                        </div>
                      )}

                    {/* Her Details */}
                    {(deleteItem?.directory?.herFirstName ||
                      deleteItem?.directory?.herLastName ||
                      deleteItem?.directory?.herEmail) && (
                        <div>
                          <span className="fw-bold">Hers:</span>{" "}
                          {deleteItem?.directory?.herFirstName}{" "}
                          {deleteItem?.directory?.herLastName}
                          {deleteItem?.directory?.herEmail && (
                            <span className="text-muted">
                              {" "}
                              – {deleteItem?.directory?.herEmail}
                            </span>
                          )}
                        </div>
                      )}
                  </div>
                </>
              )}
            </>
          }
          deleteImage={true}
          handleClose={handleClose}
          DeleteData={DeleteData}
        />

        {socialLinksModal ? (
          <SocialLinksModal
            show={socialLinksModal}
            onClose={socialLinksClose}
            directory={directory}
            setDirectory={setDirectory}
          ></SocialLinksModal>
        ) : null}

        {selectedCouple && (
          <UpdateCouplePopUp
            showRegModal={couplePopUp}
            onHide={() => setCouplePopUp(false)}
            closeButton={() => setCouplePopUp(false)}
            data={selectedCouple}
            setData={setSelectedCouple}
            ediUserIdClicked={selectedCouple?.id}
            setEdiUserIdClicked={() => { }}
            getAllCouples={() => getAllRoastersOfRetreat(id)}
            setShowREgModal={setCouplePopUp}
            parishList={parishList}
            setParishList={setParishList}
            userData={userData}
            oldValues={oldValues}
            setOldValues={setOldValues}
            isTempUpload={isTempUpload}
            setIsTempUpload={setIsTempUpload}
            CloseCompose={() => setCouplePopUp(false)}
            roasterCount={roasterCount}
            roastersOfCoupleList={roastersOfCoupleList}
            refreshRoastersOfCouple={async (coupleId) => {
              const res = await adminApi.participatedInRetreats({
                couple_Id: coupleId,
              });
              if (res.success) {
                setRoasterCount(res.totalRecords);
                setRoastersOfCoupleList(res.data);
              }
            }}
          />
        )}
        {selectedPriest && (
          <UpdatePriestPopUp
            showRegModal={priestPopUp}
            onHide={() => setPriestPopUp(false)}
            closeButton={() => setPriestPopUp(false)}
            data={selectedPriest}
            setData={setSelectedPriest}
            ediUserIdClicked={selectedPriest?.id}
            setEdiUserIdClicked={() => { }}
            getAllPriests={() => getAllRoastersOfRetreat(id)}
            setShowREgModal={setPriestPopUp}
            parishList={parishList}
            setParishList={setParishList}
            userData={userData}
            oldValues={oldValues}
            setOldValues={setOldValues}
            isTempUpload={isTempUpload}
            setIsTempUpload={setIsTempUpload}
            CloseCompose={() => setPriestPopUp(false)}
            redirect={false}
            roasterCount={roasterCount}
            roastersOfPriestList={roastersOfPriestList}
          />
        )}
      </div>
    </>
  );
};
